"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrowdMapMarkers = void 0;
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const react_1 = __importStar(require("react"));
const crowdMapSlice_1 = require("../../../../store/crowdMapSlice");
const hooks_1 = require("../../../../store/hooks");
const loadingSelectors_1 = require("../../../../store/loadingSelectors");
const markersLoadingSlice_1 = require("../../../../store/markersLoadingSlice");
const mobileSessionsSelectors_1 = require("../../../../store/mobileSessionsSelectors");
const rectangleSlice_1 = require("../../../../store/rectangleSlice");
const thresholdSlice_1 = require("../../../../store/thresholdSlice");
const mapEventListeners_1 = __importDefault(require("../../../../utils/mapEventListeners"));
const mapParamsHandler_1 = require("../../../../utils/mapParamsHandler");
const thresholdColors_1 = require("../../../../utils/thresholdColors");
const CustomMarker_1 = require("./CustomOverlays/CustomMarker");
const MapOverlay_1 = __importDefault(require("./CustomOverlays/MapOverlay"));
const RectangleInfo_1 = require("./RectangleInfo/RectangleInfo");
const CrowdMapMarkers = ({ pulsatingSessionId, sessions }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const map = (0, react_google_maps_1.useMap)();
    const { boundEast, boundNorth, boundSouth, boundWest, currentZoom, gridSize, measurementType, sensorName, tags, timeFrom, timeTo, unitSymbol, usernames, } = (0, mapParamsHandler_1.useMapParams)();
    const crowdMapRectangles = (0, hooks_1.useAppSelector)(crowdMapSlice_1.selectCrowdMapRectangles);
    const fetchingCrowdMapData = (0, hooks_1.useAppSelector)(crowdMapSlice_1.selectFetchingCrowdMapData);
    const mobileSessionsLoading = (0, hooks_1.useAppSelector)(loadingSelectors_1.selectMobileSessionsLoading);
    const mobileSessionsStreamIds = (0, hooks_1.useAppSelector)(mobileSessionsSelectors_1.selectMobileSessionsStreamIds);
    const rectangleData = (0, hooks_1.useAppSelector)(rectangleSlice_1.selectRectangleData);
    const rectangleLoading = (0, hooks_1.useAppSelector)(rectangleSlice_1.selectRectangleLoading);
    const thresholds = (0, hooks_1.useAppSelector)(thresholdSlice_1.selectThresholds);
    const preparedUnitSymbol = unitSymbol.replace(/"/g, "");
    const encodedUnitSymbol = encodeURIComponent(preparedUnitSymbol);
    const gridSizeX = (x) => {
        const width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        return (Math.round(x) * width) / height;
    };
    const filters = (0, react_1.useMemo)(() => JSON.stringify({
        east: boundEast,
        grid_size_x: gridSizeX(gridSize),
        grid_size_y: gridSize,
        measurement_type: measurementType,
        north: boundNorth,
        sensor_name: sensorName,
        south: boundSouth,
        stream_ids: mobileSessionsStreamIds,
        tags: tags,
        time_from: timeFrom,
        time_to: timeTo,
        unit_symbol: encodedUnitSymbol,
        usernames: usernames,
        west: boundWest,
        zoom: currentZoom,
    }), [
        gridSize,
        measurementType,
        mobileSessionsStreamIds,
        sensorName,
        tags,
        timeFrom,
        timeTo,
        unitSymbol,
        usernames,
        currentZoom,
    ]);
    const rectanglesRef = (0, react_1.useRef)([]);
    const [rectanglePoint, setRectanglePoint] = (0, react_1.useState)(null);
    const crowdMapRectanglesLength = crowdMapRectangles.length;
    const displayedSession = sessions.find((session) => session.id === pulsatingSessionId);
    const displayedSessionMarkerRef = (0, react_1.useRef)(null);
    const cleanupMarker = () => {
        if (displayedSessionMarkerRef.current) {
            displayedSessionMarkerRef.current.setMap(null);
            displayedSessionMarkerRef.current = null;
        }
    };
    (0, react_1.useEffect)(() => {
        dispatch((0, markersLoadingSlice_1.setMarkersLoading)(true));
    }, [crowdMapRectanglesLength, tags, usernames, dispatch]);
    (0, react_1.useEffect)(() => {
        if (!mobileSessionsLoading || fetchingCrowdMapData) {
            setRectanglePoint(null); // Clear rectanglePoint when fetching new data
            dispatch((0, crowdMapSlice_1.clearCrowdMap)());
            dispatch((0, crowdMapSlice_1.fetchCrowdMapData)(filters));
        }
    }, [dispatch, fetchingCrowdMapData, mobileSessionsLoading, currentZoom]);
    const handleRectangleClick = (rectangleBounds) => {
        const rectangleBoundEast = rectangleBounds.getNorthEast().lng();
        const rectangleBoundWest = rectangleBounds.getSouthWest().lng();
        const rectangleBoundNorth = rectangleBounds.getNorthEast().lat();
        const rectangleBoundSouth = rectangleBounds.getSouthWest().lat();
        dispatch((0, rectangleSlice_1.clearRectangles)());
        setRectanglePoint({
            lat: rectangleBoundNorth,
            lng: rectangleBoundEast,
        });
        const rectangleFilters = {
            west: rectangleBoundWest.toString(),
            east: rectangleBoundEast.toString(),
            south: rectangleBoundSouth.toString(),
            north: rectangleBoundNorth.toString(),
            time_from: timeFrom,
            time_to: timeTo,
            grid_size_x: gridSizeX(gridSize).toString(),
            grid_size_y: gridSize.toString(),
            tags: tags || "",
            usernames: usernames || "",
            sensor_name: sensorName,
            measurement_type: measurementType,
            unit_symbol: encodeURIComponent(unitSymbol),
            stream_ids: mobileSessionsStreamIds.join(","),
        };
        setTimeout(() => {
            const queryString = new URLSearchParams(rectangleFilters).toString();
            dispatch((0, rectangleSlice_1.fetchRectangleData)(queryString));
        }, 100);
    };
    (0, react_1.useEffect)(() => {
        if (!mobileSessionsLoading && crowdMapRectanglesLength > 0) {
            const newRectangles = crowdMapRectangles.map((rectangle) => {
                const newRectangle = new google.maps.Rectangle({
                    bounds: new google.maps.LatLngBounds(new google.maps.LatLng(rectangle.south, rectangle.west), new google.maps.LatLng(rectangle.north, rectangle.east)),
                    clickable: true,
                    fillColor: (0, thresholdColors_1.getColorForValue)(thresholds, rectangle.value),
                    fillOpacity: 0.6,
                    map: map,
                    strokeWeight: 0,
                });
                google.maps.event.addListener(newRectangle, "click", () => {
                    const rectangleBounds = newRectangle.getBounds();
                    if (rectangleBounds) {
                        handleRectangleClick(rectangleBounds);
                    }
                });
                return newRectangle;
            });
            rectanglesRef.current.push(...newRectangles);
        }
        // Cleanup function to remove rectangles on unmount
        return () => {
            rectanglesRef.current.forEach((rectangle) => rectangle.setMap(null));
            rectanglesRef.current = [];
        };
    }, [
        crowdMapRectangles,
        dispatch,
        gridSize,
        map,
        measurementType,
        mobileSessionsLoading,
        mobileSessionsStreamIds,
        sensorName,
        tags,
        thresholds,
        timeFrom,
        timeTo,
        unitSymbol,
        usernames,
    ]);
    (0, react_1.useEffect)(() => {
        map &&
            map.addListener("zoom_changed", () => {
                dispatch((0, rectangleSlice_1.clearRectangles)());
                setRectanglePoint(null); // Clear rectanglePoint when zoom changes
            });
    }, [dispatch, map]);
    (0, mapEventListeners_1.default)(map, {
        click: () => {
            dispatch((0, rectangleSlice_1.clearRectangles)());
            setRectanglePoint(null); // Clear rectanglePoint when map is clicked
        },
        touchend: () => {
            dispatch((0, rectangleSlice_1.clearRectangles)());
            setRectanglePoint(null);
        },
        dragstart: () => {
            dispatch((0, rectangleSlice_1.clearRectangles)());
            setRectanglePoint(null);
        },
    });
    (0, react_1.useEffect)(() => {
        if (rectanglesRef.current.length >= crowdMapRectanglesLength) {
            dispatch((0, markersLoadingSlice_1.setMarkersLoading)(false));
        }
    }, [crowdMapRectanglesLength, dispatch, rectanglesRef.current.length]);
    // Manage displayed session marker
    (0, react_1.useEffect)(() => {
        if (displayedSession && map) {
            cleanupMarker();
            const position = displayedSession.point;
            const color = (0, thresholdColors_1.getColorForValue)(thresholds, displayedSession.lastMeasurementValue);
            const marker = new CustomMarker_1.CustomMarker(position, color, "", 12);
            marker.setMap(map);
            displayedSessionMarkerRef.current = marker;
            return cleanupMarker;
        }
        else {
            cleanupMarker();
        }
    }, [displayedSession, map, thresholds]);
    return (react_1.default.createElement(react_1.default.Fragment, null, rectanglePoint && (react_1.default.createElement(MapOverlay_1.default, { position: rectanglePoint }, rectangleLoading || !rectangleData ? (react_1.default.createElement(RectangleInfo_1.RectangleInfoLoading, null)) : (react_1.default.createElement(RectangleInfo_1.RectangleInfo, { color: (0, thresholdColors_1.getColorForValue)(thresholds, rectangleData.average), rectangleData: rectangleData }))))));
};
exports.CrowdMapMarkers = CrowdMapMarkers;
